import React, { useEffect, createElement } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { PackSection } from './components/PackSection';
import { OfferSection } from './components/OfferSection';
import { TrustSection } from './components/TrustSection';
export function App() {
  // Meta Pixel Injection
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '906213565388957');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    return () => {
      // Cleanup not strictly necessary for pixel, but good practice if component unmounts
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-amber-200 selection:text-amber-900" data-id="element-0">
      <PurchasePopup data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <PackSection data-id="element-4" />
      <OfferSection data-id="element-5" />
      <TrustSection data-id="element-6" />
    </div>;
}